import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <section className="not-found" aria-labelledby="not-found-title">
      <div className="not-found-orbit not-found-orbit-outer" aria-hidden="true" />
      <div className="not-found-orbit not-found-orbit-inner" aria-hidden="true" />
      <div className="not-found-content">
        <span className="not-found-eyebrow">ProfitYo Global</span>
        <p className="not-found-code" aria-hidden="true">404</p>
        <h1 id="not-found-title">This page took a different path.</h1>
        <p className="not-found-description">
          We can’t find the page you’re looking for. It may have moved, or the
          address may be outdated.
        </p>
        <Link className="not-found-home-link" to="/">
          Return to home
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
}